module.exports = __webpack_public_path__ + "img/data-coverage.4959c130.png";